module.exports = __webpack_public_path__ + "static/media/adidas_left.20444ec7.glb";